import React from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { documentCardSx, terminalBarIconButtonSx } from '../../theme/terminalStyles';
import { formatMoney } from '../../helpers/dataFormatter';

const ACTION_SIZE = 36;
const STATUS_DOT_SIZE = 24;

const routeLabel = (doc) => doc.routeList?.name || doc.routeList?.number || '—';

const DocConfirmationDocumentCard = ({ doc, statusColor, onView, onConfirm }) => {
  const dateStr = doc.date ? new Date(doc.date).toLocaleDateString('uk-UA') : '—';
  const confirmed = Boolean(doc.isConfirmed);

  return (
    <Paper sx={documentCardSx} elevation={0}>
      <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1.5 }}>
        <Box
          sx={{
            width: ACTION_SIZE,
            minWidth: ACTION_SIZE,
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 0.25,
          }}
        >
          <IconButton
            onClick={confirmed ? onView : onConfirm}
            aria-label={confirmed ? 'Переглянути' : 'Підтвердити'}
            sx={{
              ...terminalBarIconButtonSx,
              width: ACTION_SIZE,
              height: ACTION_SIZE,
              minWidth: ACTION_SIZE,
              minHeight: ACTION_SIZE,
            }}
          >
            {confirmed ? <LockOutlinedIcon /> : <CheckCircleOutlineIcon />}
          </IconButton>
          <Box
            aria-hidden
            sx={{
              width: STATUS_DOT_SIZE,
              height: STATUS_DOT_SIZE,
              borderRadius: '50%',
              bgcolor: statusColor,
              flexShrink: 0,
            }}
          />
        </Box>
        <Box
          sx={{ flex: 1, minWidth: 0, cursor: 'pointer' }}
          onClick={onView}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onView();
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} noWrap sx={{ flex: 1 }}>
              № {doc.number}
            </Typography>
            <VisibilityOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary', flexShrink: 0 }} />
          </Box>
          <Typography variant="body2" color="text.secondary">
            {dateStr}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }} noWrap title={doc.clientName}>
            {doc.clientName || '—'}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap title={routeLabel(doc)}>
            Маршрут: {routeLabel(doc)}
          </Typography>
          <Typography variant="body1" fontWeight={600} sx={{ mt: 1 }}>
            {formatMoney(doc.sum ?? 0)} ₴
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default DocConfirmationDocumentCard;
